import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { ENABLE_WFC_PAST_DUE_BANNER } from '#client/constants/experimentsFlags';

export const BANNERS_QUERY = gql`
  query Banners($businessEntityUuid: UUID!, $enableWfcPastDueBanner: Boolean!) {
    banners(
      filter: {
        businessEntityUuid: $businessEntityUuid
        experiment: { enableWfcPastDueBanner: $enableWfcPastDueBanner }
      }
    ) {
      title
      description
      type
      imageUrl
      imageSize
      raised
      dismissible
      storageKey
      primaryCta {
        label
        modalName
        url
      }
      secondaryCta {
        label
        modalName
        url
      }
    }
  }
`;

export function useBanners() {
  const { businessEntityUuid } = useBusinessEntity();
  const enableWfcPastDueBanner = useExperimentFlag(ENABLE_WFC_PAST_DUE_BANNER, false);

  const { data, loading, error } = useQuery(BANNERS_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid,
      enableWfcPastDueBanner,
    },
  });

  useError(error);

  return {
    data: data?.banners || [],
    error,
    loading,
  };
}
